import { toast } from 'react-toastify';
import { ToastOptions } from 'react-toastify/dist/types';
import parse from 'html-react-parser';

interface IProp {
  type?: 'success' | 'error' | 'warning';
  message: string;
  options?: ToastOptions;
}

export const notification = ({ type = 'success', message, options }: IProp) =>
  toast[type](parse(`${message}`), options);
